<template>
  <div class="cancel-delete-account">
    <div v-if="errorMessage" class="delete-error-message-wrapper">
      <div class="delete-error-message-warning">
        <p>{{ $gettext('Error cancelling account deletion') }}</p>
        <div>{{ errorMessage }}</div>
      </div>
    </div>
    <p v-else class="cancel-delete-account__loading" v-translate>Cancelling account deletion</p>
  </div>
</template>

<script>
import DashboardService from '@/store/services/dashboard.service'

export default {
  name: 'CancelDeleteAccount',
  data() {
    return {
      errorMessage: null,
    }
  },
  created() {
    DashboardService.cancelDeleteProfile()
      .then(() => {
        window.location.href = window.Urls['gekkoDashboard']()
      })
      .catch(() => {
        this.errorMessage = this.$gettext(
          'An error occurred while cancelling your account deletion. Please contact support@getgekko.com for assistance.'
        )
      })
  },
}
</script>

<style lang="scss" scoped>
.cancel-delete-account__loading {
  padding: 1.5rem 1rem;
  font-size: 1rem;
  text-align: center;
}

.delete-error-message-wrapper {
  padding: 1.5rem 1rem;
}

.delete-error-message-warning {
  width: 100%;
  padding: 1rem;
  font-size: 1rem;
  text-align: center;
  color: #dc3545;
  background-color: rgba(#dc3545, 0.1);
  border: 1px solid #dc3545;
  border-radius: $radiusLg;
}
</style>
